// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2_kWT","validationTips":"StatementDescriptor_validationTips__-q2Xz"};